module.exports = __webpack_public_path__ + "static/media/klima-04.ace313fe.jpg";